module.exports = "/images/vendor/flag-icon-css/flags/4x3/mc.svg?b4f4b90da30103ef9cb0554e0111ea0d";